<div tid="entity_body" class="entity-body-container">
    <div class="entity_body_info">
        <!--standard metadata-->
        <div *ngIf="config.entity && config.entity['aliases']" class="entity_body_item">
            <div class="item-label body-3"><label>Aliases:</label></div>
            <div tid="entity_alias" class="item-value body-1">
                {{config.entity["aliases"].join(', ')}}
            </div>
        </div>
        <div *ngIf="config.entity && config.entity['webLinks']&&config.entity['webLinks'].length > 0"
            class="entity_body_item">
            <div class="item-label body-3"><label>Links:</label></div>
            <div tid="entity_links" class="item-value body-1">
                <div *ngFor="let link of config.entity['webLinks'];trackBy:trackByFn">
                    <a class="item-link" href="{{formatExternal(link['url'])}}" target="_blank">
                        {{link["title"]}}
                    </a>
                </div>
            </div>
        </div>
        <div *ngIf="config.entity && config.entity.webAddress">
            <div *ngFor="let subItem of config.entity.webAddress;let i=index;trackBy:trackByFn">
                <div class="entity_body_item"
                    *ngIf="subItem.street2||subItem.street||subItem.city||subItem.state||subItem.country||subItem.zip">
                    <span class="item-label body-3">{{i===0?'Primary Address:':'Other Address '+i+':'}} </span>
                    <span class="item-value body-1">{{subItem.street2}} {{subItem.street}} {{subItem.city}}
                        {{subItem.state}} {{subItem.country}} {{subItem.zip}}
                    </span>
                    <div><br /></div>
                </div>
            </div>
        </div>
        <div *ngIf="config.entity && config.entity['detail']&&config.entity['detail']['phone']"
            class="entity_body_item">
            <div class="item-label body-3"><label>Phone:</label></div>
            <div tid="entity_phone" class="item-value body-1">
                <span class="angular-with-newlines">
                    {{config.entity["detail"]["phone"]}}
                </span>
            </div>
        </div>
        <div *ngIf="config.entity && config.entity['detail']&&config.entity['detail']['fax']" class="entity_body_item">
            <div class="item-label body-3"><label>Fax:</label></div>
            <div tid="entity_Fax" class="item-value body-1">
                <span> {{config.entity["detail"]["fax"]}} </span>
            </div>
        </div>
        <div *ngIf="config.entity && config.entity['detail']&&config.entity['detail']['numberOfEmployees']"
            class="entity_body_item">
            <div class="item-label body-3"><label>Employees:</label></div>
            <div tid="entity_Employees" class="item-value body-1">
                <span> {{config.entity["detail"]["numberOfEmployees"]}} </span>
            </div>
        </div>
        <div *ngIf="config.entity && config.entity['detail']&&config.entity['detail']['officers']&&config.entity['detail']['officers'].length>0"
            class="entity_body_item">
            <div class="item-label body-3"><label>Officers:</label></div>
            <div tid="entity_Officers" class="item-value body-1">
                <div *ngFor="let officer of config.entity['detail']['officers'];trackBy:trackByFn" class="line-space">
                    {{officer["name"]}}{{officer["age"]?"("+officer["age"]+")":""}}{{officer["position"]?","+officer["position"]:""}}
                </div>
            </div>
        </div>
        <div *ngIf="config.entity && config.entity['detail']&&config.entity['detail']['email']"
            class="entity_body_item">
            <div class="item-label body-3"><label>Email:</label></div>
            <div tid="entity_email" class="item-value body-1">
                <a href="mailto:{{config.entity['detail']['email']}}">{{config.entity["detail"]["email"]}}</a>
            </div>
        </div>
        <div *ngIf="config.entity && !config.entity['isPublic']&&(config.entity.type&&config.entity.type.name!=='Team')"
            class="entity_body_item">
            <div class="item-label body-3">
                <label>Privacy:</label>
            </div>
            <div tid="entity_Privacy" class="item-value body-1">
                <div *ngFor="let topicMember of getPrivacy();trackBy:trackByFn" class="line-space">
                    {{topicMember['name']}}
                </div>
            </div>
        </div>
        <div *ngIf="config.entity && config.entity.type&&config.entity.type.name==='Team'" class="entity_body_item">
            <div class="item-label body-3">
                <label>Team Members:</label>
            </div>
            <div tid="entity_TeamMembers" class="item-value body-1">
                <div *ngFor="let teamMember of getEntityTeamMembers();trackBy:trackByFn" class="line-space">
                    {{teamMember['shortName']}}
                </div>
            </div>
        </div>
        <!--customized metadata-->
        <div *ngFor="let item of config.customMetadata;trackBy:trackByFn" class="entity_body_item">
            <div class="item-label body-3" [title]="item.label">
                {{item.label}}
            </div>
            <div tid="entity_customMetadata" class="item-metadata-value body-1">
                <div
                    *ngIf="item['componentType']!=='date-input'&&item['componentType']!=='nb-input'&&item['componentType']!=='tb-input'">
                    {{item.value}}
                </div>
                <div *ngIf="item['componentType'] === 'date-input'">
                    {{item.value | date: "MM/dd/yyyy"}}
                </div>
                <div *ngIf="item['componentType'] === 'nb-input'" class="item-nb-input" [innerHTML]="item.value"></div>
                <div *ngIf="item['componentType'] === 'tb-input'" class="item-text-box">{{item.value}}</div>
            </div>
        </div>
    </div>
</div>